import { Component, OnDestroy, OnInit } from '@angular/core';
import {OfficesHeaderComponent} from '../offices-header/offices-header.component'
import {HttpClient} from '@angular/common/http';
import { Subject } from 'rxjs';
import { MasterService } from 'src/app/shared/services/master.service';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { SortBy } from 'src/app/Enums/sortEnums';
import * as _ from "underscore";
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { OfficesService } from 'src/app/shared/services/offices.service';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';
import { filterData, OfficeFilter } from 'src/app/shared/classes/filter';
import { ConfirmationModalComponent } from 'src/app/shared/components/confirmation-modal/confirmation-modal.component';
import { ComponentName, ModalSize } from 'src/app/Enums/usersFilterEnums';
import { Office } from 'src/app/shared/classes/users';
import { EditOfficeComponent } from '../edit-office/edit-office.component';
import { AuditData } from 'src/app/shared/classes/AuditTrail';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';
@Component({
  selector: 'app-offices-table',
  templateUrl: './offices-table.component.html',
  styleUrls: ['./offices-table.component.less']
})
export class OfficesTableComponent implements OnInit, OnDestroy {
    modalRef: BsModalRef;
    tableSetting: any;
    usersList: any;
    userModel: any;
    cityList: any;
    statusList:any;
    totalCount: number;
    // rowsperpage: number = 10;
    currentIndex: number;
    p: number = 1;
    //offset: any;
    errorMessage: string;
    showError: boolean;
    showNoResult: boolean = false;
    displaysort: boolean = false;
    cityArray: Array<any> = new Array();
    officeArray: Array<any> = new Array();
    statusArray: Array<any> = new Array();
    filterData = {} as filterData;
    itemsperPage: number = 10;
    userName: any;
    officeID: number;
    officeName:string;
    countLength: number;
    isPaginationChange : boolean = false;
    selectedOffice:any;
    data : any = [];
  private service_URL: any;
  private unsubscribe$ =new Subject<void>();
  
  constructor(
    private httpClient : HttpClient, 
    private _masterService: MasterService,
    private officeService: OfficesService,
    private _dataContextService: DataContextService,
    private modalService: BsModalService,
    private toast: ToastrService,
    private trackeromnitureservice:TrackerOmnitureService
    ) {
        this.filterData.page = 1;
    this.service_URL = ConstantsService;
  }

  ngOnInit(): void {
    var username = localStorage.getItem('email');
    username = username.split('@')[0];
    this.trackeromnitureservice.trackPageloadData('office',username);
    this.trackeromnitureservice.trackPage("pageView");

    this.officeService.refreshPage
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {
        this.isPaginationChange = false;
        this.ResetOfficesObjects();
        this.getUsersData();
    });

        this.officeService.refreshwithFilters
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => {
            this.isPaginationChange = false;
            this.getUsersData();
        });

        this.officeService.deleteOffices
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => {
          this.DeleteAlert(this.officeID, this.selectedOffice);
        });

        this.tableSetting = {
            columns: this.tableSettingColumns()
        };

        //this.getUsers();
        this.getUsersData();        
       // this.setIntialPageCount();

    this.tableSetting = {
      columns: this.tableSettingColumns()
  };
  }
  
  ResetOfficesObjects() {
    OfficeFilter.cityList = [];
    OfficeFilter.statusList=[];
    this.userName = '';
    this.filterData.page = 1;
}

  searchOfficeByName(val) {
    this.isPaginationChange = false;
    this.userName = val;
    this.filterData.page = 1;
    this.getUsersData();
}

PrepareUsersObj() {
  //Converting Status Filter response to Boolean 
  var sArray: Array<boolean> = new Array();
  
  OfficeFilter.statusList.forEach(element => {
    element === 'Active' ? sArray.push(true) : sArray.push(false);
  });

  let params = {
      // Status: OfficeFilter.statusList,
      Status: sArray,       
      // Role: OfficeFilter.roleList,
      // Office: UsersFilterService.officesList,
      City: OfficeFilter.cityList,
      SearchByName: this.userName,
      PageNo: this.filterData.page
  };

  return params;
}

//get the city list from api
loadCityOptions(citydata: any) {
  this.cityList = citydata;
  this.cityArray = citydata;
  if (this.cityArray) {
      this.cityArray.forEach(item => {
          item.description = item.name; 
      })
  }
  if (OfficeFilter.cityList.length == 0) {
      this.cityArray.forEach(item => {
          item.isCheck = true;
      })
  }
  else {
      this.cityArray.forEach(item => {
          OfficeFilter.cityList.forEach(item1 => {
              if (item.description == item1) {
                  item.isCheck = true;
              } 
          })
      })
  }
  this.tableSetting.columns[0].isFilterIcon = true;
}

//get the status list from api
loadStatusOptions(statusdata: any) {
  this.statusList = statusdata;
  this.statusArray = statusdata;
  if (this.statusArray) {
      this.statusArray.forEach(item => {
          item.description = item.name;
      })
  }
  if (OfficeFilter.statusList.length == 0) {
      this.statusArray.forEach(item => {
          item.isCheck = true;
      })
  }
  else {
      this.statusArray.forEach(item => {
          OfficeFilter.statusList.forEach(item1=>{
              if (item.description == item1) {
                  item.isCheck = true;
              } 
          })
      })
  }
  this.tableSetting.columns[2].isFilterIcon = true;
}


setIntialPageCount(totalrecords : number)
{
    //this.totalCount = totalCount;
    this.isPaginationChange = true;
    if (totalrecords > this.itemsperPage) {
        this.countLength = this.itemsperPage;
    }
    else {
        this.countLength = totalrecords;
    }
}

deleteOffice(selectedOfficeID: number,office:Office) {
    // console.log(selectedOfficeID)
    // console.log(office)

    this.officeID = selectedOfficeID;
    this.selectedOffice=office;
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
   
// const modalsmWidth = ModalSize.Small;
    this.modalRef.setClass(ModalSize.Small);
    this.modalRef.content.title = 'Delete office';
    this.modalRef.content.description = 'Are you sure you want to delete <b>' + this.selectedOffice.officeName + '</b>?';
    this.modalRef.content.buttonsTitle = {
        dismiss: 'Cancel',
        confirm: 'Delete',
        component: ComponentName.Offices
    }
}

getUsersData() {
    let data = this.PrepareUsersObj();

    this._dataContextService.postDatawithValues<any>(this.service_URL.OfficeDetails.GetAllOfficeDetailsByFilter, data)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(res => {

        this.userModel = res;
        this.usersList = res.offices;
        //this.filterData.page = 1;
        //this.rowsperpage =3;
        this.totalCount = res.totalRecords;
        //Removing Duplicate Cities
        const result = Array.from(new Set(res.cities.map(s => s.id)))
        .map(id => {
            return {
                id: id,
                name: res.cities.find(s => s.id === id).name,
                description: res.cities.find(s => s.id === id).description,
                isCheck: res.cities.find(s => s.id === id).isCheck
            }
        })
        this.loadCityOptions(result);
        this.loadStatusOptions(res.status);   
        if(!this.isPaginationChange){this.setIntialPageCount(this.totalCount);}

    })
}

checkFilterApplied(val) {
  this.isPaginationChange = false;
  if (val) {
      this.filterData.sortBy = OfficeFilter.sortBy;
      this.filterData.sortOrder = OfficeFilter.sortOrder;
      this.filterData.page = 1;
      this.p = 1;
      this.checkFilterValue();
      this.getUsersData();
  } else {
      this.usersList = [];
  }
}

checkFilterValue() {
  this.tableSetting.columns.forEach(item => {
      if (OfficeFilter.sortBy != item.sortBy) {
          item.isFilterApplied = false;
      }
  })
}
changeCurrentPage(event) {
  //this.isPaginationChange = true;
  this.filterData.page = event.page;
  if ((this.totalCount / (this.filterData.page * this.itemsperPage) > 1)) {
      this.countLength = this.filterData.page * this.itemsperPage
  }
  else {
      this.countLength = this.totalCount;
  }
  this.getUsersData();
}

  showSortingPopup(obj) {

    _.each(this.tableSetting.columns, function (item) {
        if (item.Id != obj.Id) {
            item.displaysort = false;
        }
    })
    obj.displaysort = !obj.displaysort;
}

showEditData(selectedOfficeRow: any) {
    // console.log(selectedOfficeRow);
    
    this.modalRef = this.modalService.show(EditOfficeComponent, {
        initialState: {
            selectedOffice: selectedOfficeRow,
        },
    });        
    this.modalRef.setClass(ModalSize.Large);
}

hideDropdowns() {
  _.each(this.tableSetting.columns, function (item) {
      item.displaysort = false;
  })
}

closeDropDown() {
  _.each(this.usersList, function (item) {
      item.showAssigneeDropdown = false;
      item.showStatusDropdown = false;
  })

}

  tableSettingColumns() {
    return [
        
        {
            Id: 1,
            title: "City",
            classes: "ui_size_md",
            isSortable: true,
            isResNameSortN: true,
            sortBy: SortBy.City,
            cityDropdown: true,
            isFilterApplied: false,
            displaysort: false,
            //isOnlyFilter: true,
            isFilterIcon: true
        },
        {
            Id: 2,
            title: "Office",
            classes: "ui_size_md",
            //isResNameSortN: true,
            sortBy: SortBy.Phone,
            isFilterApplied: false,
            displaysort: false,
            isFilterIcon: false
        },
        {
            Id: 3,
            title: "Address",
            classes: "ui_size_md",
            //isResNameSortN: true,
            sortBy: SortBy.Phone,
            isFilterApplied: false,
            displaysort: false,
            isFilterIcon: false
        },
        {
            Id:4,
            title: "Status",
            classes: "ui_size_md_small",            
            isSortable: true,
            statusDropdown: true,
            //isResNameSortN: true,
            //filterWrapper: "event-type-dropdown",
            sortBy: SortBy.Status,
            isFilterApplied: false,
            displaysort: false,
            isOnlyFilter: true,
            isFilterIcon: true
        },
        // {
        //     Id: 4,
        //     title: "PostWorkingHour",
        //     classes: "ui_size_md",
        //     //isResNameSortN: true,
        //     isFilterApplied: false,
        //     displaysort: false,
        //     isFilterIcon: false
        // },
        {
            Id: 5,
            title: "Date Added",
            classes: "ui_size_md",
            //isResNameSortN: true,
            isFilterApplied: false,
            displaysort: false,
            isFilterIcon: false
        },
        {
            Id: 6,
            title: "Added By",
            classes: "ui_size_md",
            //isResNameSortN: true,
            isFilterApplied: false,
            displaysort: false,
            isFilterIcon: false
        }

    ];
}

convertToIST(date: any){
    date.setHours(date.getHours() + 5);
    date.setMinutes(date.getMinutes() + 30);
    var isodate = date.toISOString();

    return isodate;
  }

DeleteAlert(selectedOfficeID: number, office:any) {
    if(office.status = false){
        this.toast.error("Office was already deleted");
        return ;
    }
    let url = this.service_URL.OfficeDetails.DeleteOfficeId + '/' + selectedOfficeID;       
    // let data = {
    //   id: selectedOfficeID
    // };
        this._dataContextService.postDatawithValuesForDel<any>(url)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(res => {
            // console.log(res);
            if (res=="3") {                
                //ToastrComponent.success("Successfully deleted!");                
                this.toast.error("This office refered in user");
                
            }
            else if(res=="1"){
                this.toast.error("Office was deleted");
                //this.isPaginationChange = false;
                this.getUsersData();
            }
            else{
                this.toast.error("Some thing went on wrong..")
            }
            
        },
        (err) => {
            console.log(err);
        },
        () => {
            var primaryKey = this.usersList.filter((x) => {
                return x.officeID == selectedOfficeID
              })[0].officeName;
    
              var isActive = this.usersList.filter((x) => {
                return x.officeID == selectedOfficeID
              })[0].isActive;
    
              var data : AuditData = {
                  changedAttribute: 'Status',
                  oldValue: isActive ? 'Active' : 'Inactive',
                  newValue: 'Inactive'
              }
    
              if(isActive){
                let auditParams = {
                  actionPerformed : "Delete",
                  actionPerformedOn : "Office",
                  changedBy : localStorage.getItem('email'),
                  dateChanged : this.convertToIST(new Date()),
                  primaryKey : primaryKey,
                  messageText : [data]
                };
            
                this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.saveconfigaudittrail,auditParams)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((res) => {
                //   console.log(res);
                })
              }
        })
    }

ngOnDestroy(){
  this.unsubscribe$.next();
  this.unsubscribe$.complete();
}
}
